// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"az","content":"aA","header":"aB","message":"aC","iframeWrapper":"aD"};